import { createContext, useContext } from 'react'

interface CountryDataInputsContextValue {
  updateCountryDataField: (fieldName: string, valueId: string | null | undefined) => void
}

const CountryDataInputsContext = createContext<CountryDataInputsContextValue | null>(null)

export const CountryDataInputsProvider = CountryDataInputsContext.Provider

export const useCountryDataFieldChange = () => {
  const ctx = useContext(CountryDataInputsContext)
  return ctx?.updateCountryDataField
}
